import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { Tabs, tabsClasses } from '@mui/material';
import { ArrayItems, AdminRouteList } from 'types';
import { RouterTab } from './RouterTab';

export const tabPaths = [AdminRouteList.Campaigns, AdminRouteList.Users, AdminRouteList.Invoices] as const;

export const tabLabels: Record<ArrayItems<typeof tabPaths>, string> = {
  [AdminRouteList.Campaigns]: 'Campaigns',
  [AdminRouteList.Users]: 'Users',
  [AdminRouteList.Invoices]: 'Invoices',
};

export const AdminTabs = () => {
  const { pathname } = useLocation();
  const activeTab = tabPaths.find((path) => !!matchPath(path, pathname));

  return (
    <Tabs
      value={activeTab && tabPaths.indexOf(activeTab)}
      sx={{
        mb: 2,
        mt: -2,
        minHeight: 'unset',
        [`& .${tabsClasses.flexContainer}`]: {
          gap: 4,
          height: 36,
          alignItems: 'center',
        },
      }}
    >
      {tabPaths.map((path) => (
        <RouterTab key={path} label={tabLabels[path]} path={path} />
      ))}
    </Tabs>
  );
};
